const tryRequire = require('try-require')

import path from 'path'

function CSS_LOADER (paths) {
    return {
        loader: paths.FURTHER_REF + 'css-loader',
        options: {
            sourceMap: true,
            // modules: true,
            // imports: false,
            url: false,
            minimize: !paths.IS_DEV,
            importLoaders: 1
        }
    }
}

function POST_CSS (paths) {
    return {
        loader: paths.FURTHER_REF + 'postcss-loader',
        options: {
            sourceMap: true,
            cssnext: true,
            autoprefixer: true,
            cssnano: true,
            config: {
                path: path.resolve(paths.FURTHER_REF, '../', '.meta/postcss.config.js')
            }
        }
    }
}

function RESOLVE_URL (paths) {
    // return {
    //     loader: paths.FURTHER_REF + 'url-loader',
    //     options: {
    //         limit: 10240
    //     }
    // }
    return {
        loader: paths.FURTHER_REF + 'resolve-url-loader',
        options: {
            limit: 10240
        }
    }
}

function STYLE_LOADER (paths) {
    return {
        loader: paths.FURTHER_REF + 'style-loader',
        options: {
            sourceMap: true,
            minimize: !paths.IS_DEV,
            importLoaders: 1,
            discardComments: paths.IS_DEV ? false : { removeAll: true },
        }
    }
}

export function CSS(paths, config) {
    let ExtractTextPlugin = tryRequire('extract-text-webpack-plugin')
    if (!ExtractTextPlugin) {return {}} // waiting for an installation

    config.plugins = config.plugins || []
    config.plugins.push(new ExtractTextPlugin("[name].css"))

    return {
        test: /\.css$/,
        exclude: [/node_modules/],
        use: ExtractTextPlugin.extract({
            fallback: STYLE_LOADER(paths),
            use: [
                CSS_LOADER(paths),
                POST_CSS(paths),
                RESOLVE_URL(paths),
            ]
        })
    }
}

export function SASS(paths) {
    let ExtractTextPlugin = tryRequire('extract-text-webpack-plugin')
    if (!ExtractTextPlugin) {return {}} // waiting for an installation
    
    // rules for sass
    return {
        test: /\.(sass|scss)$/,
        exclude: [/node_modules/],
        use: ExtractTextPlugin.extract({
            fallback: STYLE_LOADER(paths),
            use: [
                CSS_LOADER(paths),
                RESOLVE_URL(paths),
                {
                    loader: paths.FURTHER_REF + 'sass-loader',
                    options: {
                        sourceMap: true
                    }
                },
                POST_CSS(paths)
            ]
        })
    }
}

export function LESS(paths) {
    let ExtractTextPlugin = tryRequire('extract-text-webpack-plugin')
    if (!ExtractTextPlugin) {return {}} // waiting for an installation
    
    // rules for less
    return {
        test: /\.less$/,
        exclude: [/node_modules/],
        use: ExtractTextPlugin.extract({
            fallback: STYLE_LOADER(paths),
            use: [
                CSS_LOADER(paths),
                RESOLVE_URL(paths),
                {
                    loader: paths.FURTHER_REF + "less-loader",
                    options: {
                        sourceMap: true
                    }
                },
                POST_CSS(paths)
            ]
        })
    }
}

export function STYLUS(paths) {
    let ExtractTextPlugin = tryRequire('extract-text-webpack-plugin')
    if (!ExtractTextPlugin) {return {}} // waiting for an installation
    
    // rules for less
    return {
        test: /\.(styl)$/,
        // exclude: [/node_modules/],
        use: ExtractTextPlugin.extract({
            fallback: STYLE_LOADER(paths),
            use: [
                // STYLE_LOADER,
                CSS_LOADER(paths),
                // RESOLVE_URL,
                {
                    loader: `${paths.FURTHER_REF}stylus-loader`,
                    options: {
                    // paths: `${FURTHER_REF}bootstrap-stylus/stylus/`
                    paths: `${paths.FURTHER_REF}bootstrap-styl`
                    }
                }//,
                // POST_CSS
            ]
        })
    }
}



// WEBPACK FOOTER //
// ./src/technologies/styles.js